import cloneDeep from 'lodash/cloneDeep'
import { SelectUnitRow } from '../features/SelectUnits/types'

export const getUnitNumbers = ({
  allRows,
  isCreate,
}: {
  allRows: SelectUnitRow[]
  isCreate?: boolean
}) => {
  const result: any[] = []
  try {
    cloneDeep(allRows).forEach((x) => {
      if (x.isSelected) {
        if (isCreate) {
          if (x.isCovered === undefined) x.isCovered = false
          if (x.isClimate === undefined) x.isClimate = false
          result.push(x)
        } else result.push(x.unitNumber)
      }
    })
  } catch (error) {
    console.log({ error })
  }

  return result
}
